import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "hot-container"
};
const _hoisted_2 = {
  class: "hot-dashboard"
};
const _hoisted_3 = {
  class: "platform-grid"
};
const _hoisted_4 = {
  class: "card-header"
};
const _hoisted_5 = {
  class: "header-right"
};
const _hoisted_6 = {
  class: "header-badge"
};
const _hoisted_7 = ["onClick", "disabled", "title"];
const _hoisted_8 = {
  class: "card-content"
};
const _hoisted_9 = {
  key: 0,
  class: "loading"
};
const _hoisted_10 = {
  key: 1,
  class: "error-state"
};
const _hoisted_11 = {
  class: "error-msg"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["href", "title"];
const _hoisted_14 = {
  key: 0,
  class: "hot-metric"
};
const _hoisted_15 = {
  key: 0,
  class: "empty-state"
};
import { reactive, computed, onMounted, onBeforeUnmount } from 'vue';
import { PLATFORM_FETCHERS } from '@/api/index';

// 平台配置
const CACHE_TTL = 60 * 1000;
export default {
  __name: 'Redian',
  setup(__props) {
    const platforms = [{
      id: 'weibo',
      name: '微博热搜'
    }, {
      id: 'zhihu',
      name: '知乎热榜'
    }, {
      id: 'baidu',
      name: '百度热搜'
    }, {
      id: 'bilibili',
      name: 'B站热门'
    }, {
      id: 'douyin',
      name: '抖音热点'
    }, {
      id: 'toutiao',
      name: '今日头条'
    }, {
      id: 'thepaper',
      name: '澎湃新闻'
    }, {
      id: '36kr',
      name: '36氪'
    }, {
      id: 'huxiu',
      name: '虎嗅'
    }, {
      id: 'hupu',
      name: '虎扑热帖'
    }, {
      id: 'ithome',
      name: 'IT之家'
    }, {
      id: 'woshipm',
      name: '产品经理'
    }];

    // 用 computed 保持响应式
    const visiblePlatforms = computed(() => platforms);
    const hotData = reactive({});
    const platformLoading = reactive({});
    const platformErrors = reactive({});

    // 内存缓存：60 秒内不重复请求相同平台
    const memCache = new Map(); // platformId -> { data, ts }

    // 用于取消 in-flight 请求
    let cancelled = false;

    // 获取当前时间简写
    const getTimeStr = () => {
      const d = new Date();
      return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    // 单个平台数据获取（带缓存 + 取消）
    const fetchPlatform = async platform => {
      const fetcher = PLATFORM_FETCHERS[platform.id];
      if (!fetcher) return;

      // 命中缓存直接返回
      const cached = memCache.get(platform.id);
      if (cached && Date.now() - cached.ts < CACHE_TTL) {
        hotData[platform.id] = cached.data;
        platformErrors[platform.id] = null;
        const idx = platforms.findIndex(p => p.id === platform.id);
        if (idx !== -1) platforms[idx].updateTime = cached.time;
        return;
      }
      platformLoading[platform.id] = true;
      platformErrors[platform.id] = null;
      try {
        const data = await fetcher();
        if (cancelled) return;
        const sliced = data.slice(0, 9);
        hotData[platform.id] = sliced;
        // 写入缓存
        const time = getTimeStr();
        memCache.set(platform.id, {
          data: sliced,
          ts: Date.now(),
          time
        });
        const idx = platforms.findIndex(p => p.id === platform.id);
        if (idx !== -1) platforms[idx].updateTime = time;
      } catch (e) {
        if (cancelled) return;
        platformErrors[platform.id] = '获取失败';
        hotData[platform.id] = [];
      } finally {
        platformLoading[platform.id] = false;
      }
    };

    // 并发池：限制同时最多 N 个请求，避免一次发 12 个撞 Cloudflare 限流
    const runWithConcurrency = async (tasks, limit = 4) => {
      const queue = [...tasks];
      const workers = Array.from({
        length: Math.min(limit, queue.length)
      }, async () => {
        while (queue.length) {
          const t = queue.shift();
          if (!t) break;
          if (cancelled) break;
          await t();
        }
      });
      await Promise.all(workers);
    };

    // 批量获取：页面加载时一次拉全部，使用缓存
    const fetchAllPlatforms = async () => {
      cancelled = false;
      await runWithConcurrency(platforms.map(p => () => fetchPlatform(p)), 4);
    };

    // 单个平台强制刷新（清该平台缓存后重拉）
    const refreshPlatform = async platform => {
      memCache.delete(platform.id);
      await fetchPlatform(platform);
    };
    onMounted(() => {
      fetchAllPlatforms();
    });
    onBeforeUnmount(() => {
      // 组件卸载时取消所有 in-flight 请求，避免回退页面时污染下一次进入
      cancelled = true;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("main", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePlatforms.value, platform => {
        return _openBlock(), _createElementBlock("div", {
          key: platform.id,
          class: _normalizeClass(["platform-card", {
            'card-error': platformErrors[platform.id]
          }])
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", null, _toDisplayString(platform.name), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(platform.updateTime || '--'), 1), _createElementVNode("button", {
          class: "card-refresh-btn",
          onClick: _withModifiers($event => refreshPlatform(platform), ["stop"]),
          disabled: platformLoading[platform.id],
          title: '刷新' + platform.name
        }, [(_openBlock(), _createElementBlock("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "12",
          height: "12",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          class: _normalizeClass({
            spinning: platformLoading[platform.id]
          })
        }, [...(_cache[0] || (_cache[0] = [_createElementVNode("polyline", {
          points: "23 4 23 10 17 10"
        }, null, -1), _createElementVNode("path", {
          d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
        }, null, -1)]))], 2))], 8, _hoisted_7)])]), _createElementVNode("div", _hoisted_8, [platformLoading[platform.id] ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
          class: "loading-dot"
        }, null, -1)]))])) : platformErrors[platform.id] ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString(platformErrors[platform.id]), 1), _createElementVNode("button", {
          class: "retry-btn",
          onClick: $event => fetchPlatform(platform)
        }, "重试", 8, _hoisted_12)])) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotData[platform.id] || [], (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "hot-item",
            key: item.id || index
          }, [_createElementVNode("span", {
            class: _normalizeClass(["hot-rank", {
              'top-3': index < 3
            }])
          }, _toDisplayString(index + 1), 3), _createElementVNode("a", {
            href: item.url,
            target: "_blank",
            class: "hot-title",
            title: item.title
          }, _toDisplayString(item.title), 9, _hoisted_13), item.hot ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.hot), 1)) : _createCommentVNode("", true)]);
        }), 128)), !(hotData[platform.id] || []).length ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", null, "暂无数据", -1)]))])) : _createCommentVNode("", true)], 64))])], 2);
      }), 128))])])]);
    };
  }
};